export const CrownLogo = ({ size = 56, ring = true }) => (
  <svg width={size} height={size} viewBox="0 0 56 56" aria-hidden="true">
    {ring && <circle cx="28" cy="28" r="27" fill="#0E0E10" stroke="#2A2A2E" strokeWidth="1" />}
    <path d="M14 37 L12 18 L21 27 L28 14 L35 27 L44 18 L42 37 Z" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinejoin="round" />
    <path d="M14 41.5 H42" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="12" cy="17" r="1.8" fill="none" stroke="#FFFFFF" strokeWidth="1.6" />
    <circle cx="28" cy="12.6" r="1.8" fill="none" stroke="#FFFFFF" strokeWidth="1.6" />
    <circle cx="44" cy="17" r="1.8" fill="none" stroke="#FFFFFF" strokeWidth="1.6" />
  </svg>
);

export const SunflowerLogo = ({ size = 56, ring = true }) => (
  <svg width={size} height={size} viewBox="0 0 56 56" aria-hidden="true">
    {ring && <circle cx="28" cy="28" r="27" fill="#0E0E10" stroke="#2A2A2E" strokeWidth="1" />}
    {Array.from({ length: 14 }).map((_, i) => (
      <ellipse key={i} cx="28" cy="15.5" rx="3.6" ry="8" fill="#F4C542" stroke="#D9A92E" strokeWidth="0.4" transform={`rotate(${(360 / 14) * i} 28 28)`} />
    ))}
    <circle cx="28" cy="28" r="8.2" fill="#4A2617" />
    {[[-3, -3], [3, -3], [0, 0], [-3, 3], [3, 3], [0, -5], [0, 5], [-5, 0], [5, 0]].map(([x, y], i) => (
      <circle key={i} cx={28 + x} cy={28 + y} r="0.9" fill="#7A4A2E" />
    ))}
  </svg>
);

export const UserLogo = ({ id, size = 36, ring = true }) =>
  id === "alexis" ? <CrownLogo size={size} ring={ring} /> : <SunflowerLogo size={size} ring={ring} />;
